// extracted by mini-css-extract-plugin
module.exports = {"Delivery":"Delivery_Delivery__4Bvz8"};